import { createActionName } from "../../../utility"

export const reducerName = "todo"

export const TODO = createActionName(reducerName, "TODO")
export const TODOS = createActionName(reducerName, "TODOS")
